import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33c4640b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33c4640b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4640b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c4640b')) {
      api.createRecord('33c4640b', component.options)
    } else {
      api.reload('33c4640b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33c4640b&scoped=true", function () {
      api.rerender('33c4640b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WarningTrajectoryTip/index.vue"
export default component.exports